<app-dialog-base [Title]='"Geozone"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="inputgroup">
    <label>{{'Name'|translate }}</label>
    <input type="text" placeholder="{{'Name'|translate }}" [(ngModel)]="model.Name" />
  </div>
  <div class="inputgroup">
    <label>{{'Description'|translate }}</label>
    <input type="text" [(ngModel)]="model.Comment" />
  </div>
  <div class="inputgroup">
    <label>{{'Max speed'|translate}}</label>
    <div class="input-number">
      <div class="input-number-control">
        <input type="number" [(ngModel)]="model.MaxSpeed">
      </div>
      <div class="input-number-text">{{'km/h'|localizeUnits}}</div>
    </div>
  </div>
  <div class="inputgroup" *ngIf="model.Style.type == 'point' || model.Style.type == 'polyline'">
    <label>{{'Radius'|translate}}</label>
    <div class="input-number">
      <div class="input-number-control">
        <input type="number" [(ngModel)]="model.Radius">
      </div>
      <div class="input-number-text">{{'m'|localizeUnits}}</div>
    </div>
  </div>

  <app-base-group-mgmt-component [Title]="'Groups'" [Objects]="model.GroupIds" [groups]="groups" style="z-index: 1;">
    <ng-template let-item>
      <td>{{item.Name}}</td>
    </ng-template>
  </app-base-group-mgmt-component>
</app-dialog-base>